import React from 'react';

const MassAdminConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SUPER_ADMIN', 'FRANCHISEE_BULK_PRICES_AND_OPERATIONS_ALL'],
  routes: [
    {
      path: '/mass-administration',
      exact: true,
      component: React.lazy(() => import('./massAdminList'))
    }
  ]
};

export default MassAdminConfig;
